import store from '../store';

/** 后端错误提示（中文）→ 英文；key 须与 response.data.msg 完全一致 */
const ERROR_MSG_I18N_MAP = {
  '当前时段已满': 'This time slot is fully booked.',
  '预约时段已满，请联系峰会小助手确认电话沟通时间':
    'The selected time slot is fully booked. Please contact the HSYLC Assistant to confirm an alternative interview time.',
  '你已预约过该活动，请勿重复预约':
    'You have already booked this activity. Please do not book it again.'
};

/**
 * 拦截器错误提示中英映射（仅 en / 非 en 二值）
 * @param {string} msg 后端 response.data.msg
 * @returns {string}
 */
export function mapApiErrorMsg(msg = '') {
  if (!(msg && msg.length)) {
    return msg;
  }
  if (store.getters.getLanguage !== 'en') {
    return msg;
  }
  return ERROR_MSG_I18N_MAP[msg] || msg;
}
